import { Token, getWacValue, WacTokenNotInAds } from "./token-types";

const wacToken = (token: Token) => {
    return getWacValue(token as WacTokenNotInAds);
};

export default wacToken;
